
import {
    BooleanField,
    NumberField,
    Show,
    TextField
} from '@/components/admin';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { Tag, ArrowLeft } from 'lucide-react';
import { useRecordContext } from 'ra-core';
import { Link } from 'react-router-dom';

const ShowTitle = () => {
    const record = useRecordContext();
    if (!record) return null;
    return (
        <div className="flex items-center gap-3">
            <Button asChild variant="outline" size="sm" className="gap-1.5 bg-primary/10 hover:bg-primary/20 text-primary border-primary/20 font-semibold cursor-pointer h-9 px-4 rounded-lg">
                <Link to="/hsn_codes" className="flex items-center gap-1.5">
                    <ArrowLeft className="w-4 h-4" /> Back to HSN / SAC Codes
                </Link>
            </Button>
            <span className="text-xl font-bold tracking-tight text-slate-900 ml-1">{record.code}</span>
        </div>
    );
};

export const HSNCodeShow = () => (
    <Show title={<ShowTitle />}>
        <div className="max-w-4xl mx-auto space-y-4">
            <Card className="w-full shadow-sm">
                <CardHeader className="pb-3 border-b bg-slate-50/50">
                    <div className="flex items-center gap-2">
                        <Tag className="w-5 h-5 text-indigo-500" />
                        <CardTitle className="text-lg font-semibold tracking-tight">HSN / SAC Code</CardTitle>
                    </div>
                </CardHeader>
                <CardContent className="pt-6 space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">Code</p>
                            <TextField source="code" className="font-mono text-lg font-bold" />
                        </div>
                        <div>
                            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">UQC</p>
                            <TextField source="uqc" />
                        </div>
                        <div>
                            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">Is Service</p>
                            <BooleanField source="is_service" />
                        </div>
                    </div>

                    <div>
                        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">Description</p>
                        <TextField source="description" />
                    </div>

                    <div>
                        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">Category</p>
                        <TextField source="category" />
                    </div>

                    <Separator className="my-2" />

                    <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">GST Rate Breakdown</p>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        <div>
                            <p className="text-xs text-slate-500 mb-1">Total GST %</p>
                            <NumberField source="gst_rate" />
                        </div>
                        <div>
                            <p className="text-xs text-slate-500 mb-1">CGST %</p>
                            <NumberField source="cgst_rate" />
                        </div>
                        <div>
                            <p className="text-xs text-slate-500 mb-1">SGST / UTGST %</p>
                            <NumberField source="sgst_rate" />
                        </div>
                        <div>
                            <p className="text-xs text-slate-500 mb-1">IGST %</p>
                            <NumberField source="igst_rate" />
                        </div>
                    </div>

                    <div>
                        <p className="text-xs text-slate-500 mb-1">Cess %</p>
                        <NumberField source="cess_rate" />
                    </div>
                </CardContent>
            </Card>
        </div>
    </Show>
);
